import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import HomePage from '../pages/HomePage'
import UserVideosPage from '../pages/UserVideosPage'
import PlansPage from '../pages/PlansPage'
import TermsPage from '../pages/TermsPage'
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage'
import { Register, Activate, Login, ResetPassword } from '../pages/LoginPage'

import Navigation from '../components/Navigation'
import Footer from '../components/Footer'


/*
 * Main application container.
 */
export default class App extends Component {
  render() {
    return (
      <Router>
        <div className="app">
          <Navigation />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/mycollection" component={UserVideosPage} />
            <Route exact path="/packages" component={PlansPage} />
            <Route exact path="/terms" component={TermsPage} />
            <Route exact path="/privacy" component={PrivacyPolicyPage} />

            <Route exact path="/register" component={Register} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/activate/:token" component={Activate} />
            <Route exact path="/reset" component={ResetPassword} />
            <Route exact path="/reset/:token" component={ResetPassword} />

            <Route component={HomePage} />
          </Switch>
          <Footer />
        </div>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/App.js